import React from 'react';
import { Box, Skeleton, TableCell, TableRow } from '@mui/material';
import { spaces } from '../../../../assets/styles/themes/tokens';

/** Placeholder for <OrderTotalSummary> (label + headline monthly price + term). */
export const PriceSummarySkeleton: React.FC = () => (
  <Box
    data-testid='stripe-checkout-price-skeleton'
    sx={{ display: 'flex', flexDirection: 'column', gap: spaces.sm }}
  >
    <Skeleton variant='text' width={120} />
    <Box>
      <Skeleton variant='text' width={160} height={48} />
      <Skeleton variant='text' width={100} />
    </Box>
  </Box>
);

/** Placeholder for the payment methods (three selectable option cards). */
export const PaymentFormSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: spaces.md }}>
    {[0, 1, 2].map((card) => (
      <Skeleton key={card} variant='rounded' height={56} />
    ))}
  </Box>
);

/**
 * Placeholder rows for <CheckoutPriceTable> (amount due today + total). Rendered
 * inside the summary's shared <TableBody>, so it must return bare <TableRow>s.
 */
export const PriceTableSkeleton: React.FC = () => (
  <>
    {[0, 1].map((row) => (
      <TableRow key={row}>
        <TableCell sx={{ paddingX: 0 }}>
          <Skeleton variant='text' width={110} />
        </TableCell>
        <TableCell sx={{ paddingX: 0 }} align='right'>
          <Skeleton variant='text' width={80} sx={{ marginLeft: 'auto' }} />
        </TableCell>
      </TableRow>
    ))}
  </>
);
